import { configureStore } from "@reduxjs/toolkit";

import challengeSlice from "./features/challengeSlice";
import userSlice from "./features/userSlice";
import ktkSlice from "./features/ktkSlice";

const store = configureStore({
  reducer: {
    challenges: challengeSlice,
    user: userSlice,
    ktk: ktkSlice,
  },
});

export default store;
